import React from 'react';
import { IStudentFlow, IStudentSpeakingState, IVerbaScholaStudentStep, VerbaScholaApi } from '../api/VerbaScholaApi';

type AttemptTransport = {
    preview: boolean;
    createAttempt: typeof VerbaScholaApi.createStudentAttempt;
};

const liveTransport: AttemptTransport = { preview: false, createAttempt: VerbaScholaApi.createStudentAttempt };
const Context = React.createContext<AttemptTransport>(liveTransport);

export function useStudentAttemptTransport(): AttemptTransport { return React.useContext(Context); }

/** The provider is scoped to one teacher preview step. Only temporary state is retained. */
export function VerbaScholaStudentPreviewTransport({ step, children, unchecked = false }: { step: IVerbaScholaStudentStep; children: React.ReactNode;
    /** A proposed step that exists only in a review projection: actions are refused. */
    unchecked?: boolean }) {
    const state = React.useRef<IStudentSpeakingState | IStudentFlow['state'] | undefined>(step.speaking?.state ?? step.flow?.state);
    const transport = React.useMemo<AttemptTransport>(() => ({
        preview: true,
        createAttempt: async (stepId, payload, timeout) => {
            if (unchecked) throw new Error('proposed_step_not_checked');
            const response = await VerbaScholaApi.createTeacherStudentPreviewAction(stepId, { ...payload, preview_state: state.current }, timeout);
            state.current = response.data.speaking?.state ?? response.data.flow?.state ?? state.current;
            return response;
        },
    }), [unchecked]);
    return <Context.Provider value={transport}>{children}</Context.Provider>;
}
